document.addEventListener('DOMContentLoaded', (e) => {
  ;(function () {
    if (document.querySelector('#shopify-section-annoucement')) {
      const clonedAnnouncementBar = document
        .querySelector('#shopify-section-annoucement')
        .cloneNode(true)
      document
        .querySelector('#shopify-section-annoucement')
        .classList.add('desktopAnnoucementBar')
      document.querySelector('#shopify-section-annoucement').className +=
        ' block'
      clonedAnnouncementBar.classList.add('mobileAnnoucementBar')
      clonedAnnouncementBar.className += ' block '
      if (document.querySelector('#MainContent .main_loyality_section')) {
        document.querySelector('#MainContent .main_loyality_section').parentElement.insertBefore(clonedAnnouncementBar,document.querySelector('#MainContent .main_loyality_section'))
      } else if(document.querySelector('#MainContent').firstElementChild.classList.contains('page-header')) {
          document
            .querySelector('#MainContent')
            .insertBefore(
              clonedAnnouncementBar,
              document.querySelector('#MainContent').firstElementChild
            )
      }else{
        document.querySelector('#MainContent').insertBefore(
          clonedAnnouncementBar,
          document.querySelector('#MainContent .shopify-section:first-child')
        )
      }
    
      document
        .querySelectorAll('#shopify-section-annoucement')
        .forEach((announcementBar) => {
          if (announcementBar.classList.contains('mobileAnnoucementBar')) {
            new Swiper(
              announcementBar.querySelector('.announcement-bar__content'),
              {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                navigation: {
                  nextEl: '.mobileAnnoucementBar .nextSliderBtn ',
                  prevEl: '.mobileAnnoucementBar .prevSliderBtn ',
                },
              }
            )
          } else {
            /* new Swiper(
              announcementBar.querySelector('.announcement-bar__content'),
              {
                slidesPerView: 1,
                slidesPerGroup: 3,
                loop: true,
                autoplay: {
                  delay: 2000,
                  disableOnInteraction: false,
                },
              }
            ) */
          }
        })
    }
  })()
  
 ;(function () {
    new Swiper('.announcement-bar__content', {
  // Optional parameters

  loop: true,
      autplay:true
});
  })()
  
  
  ;(function () {
    if (document.querySelector('#subscribeToNewsletter')) {
      document.querySelectorAll('#subscribeToNewsletter').forEach((consentCheckbox) => {
        consentCheckbox.addEventListener('change', e=>{
            if(e.target.checked)
                e.target.closest('form').querySelector('#newsletterConsentTag').value = 'Shopify Account Creation, ' + 'Subscribed To Marketing'
            else
                e.target.closest('form').querySelector('#newsletterConsentTag').value = 'Shopify Account Creation, ' + 'Did not consent to marketing'
        })
      })
    }

    if(document.querySelector('#footerEmbedConsentInput')){
        document.querySelector('#footerEmbedConsentInput').addEventListener('change', e=>{
            if(e.target.checked)
                e.target.closest('form').querySelector('.contactTags').value = 'Shopify Footer Embed Form, ' + 'Subscribed To Marketing'
            else
                e.target.closest('form').querySelector('.contactTags').value = 'Shopify Footer Embed Form, ' + 'Did not consent to marketing'
        })
    }
  })()
  ;(function () {
    if (document.querySelector('.icons-swiper')) {
      document.querySelectorAll('.icons-swiper').forEach((iconWiper) => {
        new Swiper(iconWiper, {
          slidesPerView: 4.55,
          loop: false,
          allowSlideNext: true,
          allowSlidePrev: true,
          allowTouchMove: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        })
      })
    }
  })()

  ;(function () {
    var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

        initGorgiasChatPromise.then(function () {

            var timer = setInterval(function () {
                var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
                if (!chatButtonHead || ![...chatButtonHead?.children].some(x => x.getAttribute("data-emotion"))) {
                    return;
                }
                clearInterval(timer);

                var buttonStyle = document.createElement('style');
                buttonStyle.textContent = '[aria-label="Open the chat"] {display: none !important;}'; // the custom CSS for the chat button
                chatButtonHead.appendChild(buttonStyle);
/*
                GorgiasChat.setCustomBusinessHours({
                  // Using a timezone from https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
                  // Day 1 represents Monday, Day 7 represents Sunday
                  timezone: "Australia/Sydney", 
                  businessHours: [
                      { days: [1, 2, 3, 4, 5], fromTime: "09:00", toTime: "17:00" },
                  ]
                })*/
              
                document.querySelector('.liveChatBtn').addEventListener('click', (e) => {
                    if(GorgiasChat.isBusinessHours()){
                      e.preventDefault();
                      if(GorgiasChat){
                        GorgiasChat.open()
                        document.querySelector('.liveChatBtn').innerText = 'live chat with us'
                      }
                    }else{
                      document.querySelector('.liveChatBtn').innerText = 'Email Us'
                    }
                  })

                  setTimeout(()=>{
                    if(!GorgiasChat.isBusinessHours()){
                      document.querySelector('.liveChatBtn').innerText = 'Email Us'
                    }
                  }, 2000)
            }, 50);
        })
  })()

    ;(function () {
    if (document.querySelector('.sf-menu-content .sf-menu-close')) {
      document.querySelector('.sf-menu-content .sf-menu-close').addEventListener('click', e=>{
        e.preventDefault();
        if(!document.querySelector('.sf-menu-content .sf-menu-close').closest('.sf-menu__content')?.classList.contains('.-translate-x-full')){
          document.querySelector('.sf-menu-wrapper.sf-menu-wrapper-mobile').click()
        }
      })
    }
  })()
    ;(function () {
         if(document.querySelector('.home-banner__custom-slideshow')){
        document.querySelectorAll('.home-banner__custom-slideshow').forEach(topBanner => {
          if(topBanner.querySelectorAll('.swiper-slide').length > 1){
            const sectionSpecificClass= topBanner.querySelector('.swiper-container').getAttribute('data-section-id')
            new Swiper(topBanner.querySelector('.swiper-container'), {
              slidesPerView: 1,
              loop: true,
              allowSlideNext: true,
              allowSlidePrev: true,
              allowTouchMove: true,
              autoplay: {
                 delay: 5000,
                 disableOnInteraction: false,
             },
              navigation: {
                nextEl: "." + sectionSpecificClass + " .swiper-button-next",
                prevEl:  "." + sectionSpecificClass + " .swiper-button-prev",
              },
              pagination: {
                el: topBanner.querySelector(".swiper-pagination"),
                clickable: true,
              },
            })
          }
        })
      }
  })();


  ;(function () {
    if (document.querySelector('m-icons-with-title')) {
      document.querySelectorAll('.m-icons-with-title').forEach((iconWiper) => {
        new Swiper(iconWiper, {
          slidesPerView: 'auto',
          loop: false,
          allowSlideNext: true,
          allowSlidePrev: true,
          allowTouchMove: true,
          spaceBetween: 50,
        })
      })
    }
  })()

  ;(function () {
    if (document.querySelector('.custom-brand-slider-container')) {
      document
        .querySelectorAll('.custom-brand-slider-container .custom-brand-slider')
        .forEach((customSlide) => {
          let sectionSpecificClass = customSlide.getAttribute('data-section-id')
          new Swiper(customSlide, {
            slidesPerView: '1',
            slidesPerGroup: 1,
            loop: true,
            allowSlideNext: true,
            allowSlidePrev: true,
            allowTouchMove: true,
            spaceBetween: 80,
            navigation: {
              nextEl: '.' + sectionSpecificClass + ' .nextSliderBtn',
              prevEl: '.' + sectionSpecificClass + ' .prevSliderBtn',
            },
            pagination: {
              el: customSlide.querySelector('.swiper-pagination'),
              bulletElement: 'span',
              clickable: false,
              hideOnClick: false,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: false,
              type: 'bullets',
              // 'bullets' or 'progressbar' or 'fraction' or 'custom'
              dynamicBullets: false,
              dynamicMainBullets: 1,
              formatFractionCurrent: function formatFractionCurrent(number) {
                return number
              },
              formatFractionTotal: function formatFractionTotal(number) {
                return number
              },
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
              modifierClass: 'swiper-pagination-',
              // NEW
              currentClass: 'swiper-pagination-current',
              totalClass: 'swiper-pagination-total',
              hiddenClass: 'swiper-pagination-hidden',
              progressbarFillClass: 'swiper-pagination-progressbar-fill',
              progressbarOppositeClass:
                'swiper-pagination-progressbar-opposite',
              clickableClass: 'swiper-pagination-clickable',
              // NEW
              lockClass: 'swiper-pagination-lock',
            },
          })
        })
    }
  })()

  const initiateCustomAccordions = () => {
    if (!customElements.get('collapsible-tab-custom')) {
      class e extends HTMLElement {
        constructor() {
          super()
        }
        connectedCallback() {
          this.init()
        }
        disconnectedCallback() {
          this.destroy()
        }
        init = () => {
          'true' === this.dataset.destroy ||
            (this.setDefaultData(),
            this.attachEvents(),
            'true' === this.getAttribute('open')
              ? ((this.selected = !0),
                this.classList.add(this.expandedClass),
                this.setExpandedAria())
              : ((this.content.style.height = this.collapsedHeight),
                this.classList.add(this.collapsedClass),
                this.setCollapsedAria()),
            this.content.removeAttribute('hidden'))
        }
        transitionendEventName = () => {
          let e,
            t = document.createElement('div'),
            s = {
              transition: 'transitionend',
              OTransition: 'otransitionend',
              MozTransition: 'transitionend',
              WebkitTransition: 'webkitTransitionEnd',
            }
          for (e in s)
            if (s.hasOwnProperty(e) && void 0 !== t.style[e]) return s[e]
        }
        expand = () => {
          const e = ((t) => {
            t.target === this.content &&
              (this.content.removeEventListener(this.transitionendevent, e),
              this.isOpen &&
                requestAnimationFrame(() => {
                  ;(this.content.style.transition = '0'),
                    (this.content.style.height = 'auto'),
                    requestAnimationFrame(() => {
                      ;(this.content.style.height = null),
                        (this.content.style.transition = null),
                        this.setExpandedAria(),
                        this.classList.add(this.expandedClass),
                        this.trySetTabIndex(this.content, 0),
                        this.fire('tabOpened')
                    })
                }))
          }).bind(this)
          this.content.addEventListener(this.transitionendevent, e),
            (this.isOpen = !0),
            this.classList.remove(this.collapsedClass),
            (this.content.style.height = this.content.scrollHeight + 'px')
        }
        collapse = () => {
          const e = ((t) => {
            t.target === this.content &&
              (this.content.removeEventListener(this.transitionendevent, e),
              this.isOpen ||
                (this.fire('elementClosed'),
                this.setCollapsedAria(),
                this.classList.add(this.collapsedClass),
                this.trySetTabIndex(this.content, -1)))
          }).bind(this)
          this.content.addEventListener(this.transitionendevent, e),
            (this.isOpen = !1),
            this.classList.remove(this.expandedClass),
            requestAnimationFrame(() => {
              ;(this.content.style.transition = '0'),
                (this.content.style.height = this.content.scrollHeight + 'px'),
                requestAnimationFrame(() => {
                  ;(this.content.style.transition = null),
                    (this.content.style.height = this.collapsedHeight)
                })
            })
        }
        open = () => {
          ;(this.selected = !0),
            this.fire('elementSelected'),
            this.expand(),
            this.setAttribute('open', !0)
        }
        close = () => {
          ;(this.selected = !1),
            this.fire('elementUnselected'),
            this.collapse(),
            this.removeAttribute('open')
        }
        toggle = (e) => {
          e?.preventDefault()
          if ((e?.preventDefault(), this.selected)) this.close()
          else if ((this.open(), this.oneAtATime)) {
            const e = document.querySelectorAll('collapsible-tab'),
              t = this.closest('[data-first-level]')
            e.length &&
              e.forEach((e) => {
                e !== this && e.selected && t !== e && e.close()
              })
          }
        }
        trySetTabIndex(e, t) {
          const s = e.querySelectorAll(this.defaultElements)
          s &&
            s.forEach((e) => {
              e.setAttribute('tabindex', t)
            })
        }
        setExpandedAria = () => {
          this.trigger.setAttribute('aria-expanded', 'true'),
            this.content.setAttribute('aria-hidden', 'false')
        }
        setCollapsedAria = (e) => {
          this.trigger.setAttribute('aria-expanded', 'false'),
            this.content.setAttribute('aria-hidden', 'true')
        }
        attachEvents = () => {
          this.trigger.addEventListener('click', (e) => this.toggle(e))
        }
        setDefaultData = () => {
          ;(this.events = {
            elementSelected: [],
            tabOpened: [],
            elementUnselected: [],
            elementClosed: [],
          }),
            (this.transitionendevent = this.transitionendEventName()),
            (this.expandedClass = 'is-expanded'),
            (this.collapsedClass = 'is-collapsed'),
            (this.trigger = this.querySelector('[data-trigger]')),
            (this.content = this.querySelector('[data-content]')),
            (this.collapsedHeight = '0px'),
            (this.defaultElements = [
              'a',
              'button',
              'input:not(.focus-none)',
              '[data-trigger]',
            ]),
            (this.oneAtATime = !0),
            this.dataset.oneOpen &&
              (this.oneAtATime = 'true' === this.dataset.oneOpen)
        }
        fire = (e) => {
          let t = this.events[e]
          for (let e = 0; e < t?.length; e++) t[e](this)
        }
        on = (e, t) => {
          this.events[e] && this.events[e].push(t)
        }
        destroy = () => {
          this.trigger.removeEventListener('click', (e) => this.toggle(e)),
            this.content.removeAttribute('aria-hidden'),
            (this.content.style.height = 'auto'),
            this.classList.remove(this.expandedClass, this.collapsedClass),
            this.removeAttribute('open')
        }
      }
      customElements.define('collapsible-tab-custom', e)
    }
  }

  ;(function () {
    //Moving Details tab to the left
    /*
    if (
      document.querySelector('.sf-prod__block') &&
      document.querySelector('.sf-product__section-tabs')
    ) {
      document
        .querySelector('.sf-prod__block')
        .appendChild(document.querySelector('.sf-product__section-tabs'))
      //Custom Accordion Event Handler

      document
        .querySelectorAll(
          '.sf-prod__block .sf-product__section-tabs collapsible-tab-custom:not(.questionAndAnswers):not(.customReview)'
        )
        .forEach((tab) => {
          let removedNewLines = tab
            .querySelector('.collapsible__content')
            .innerText.replaceAll('\n', '')
          removedNewLines = removedNewLines.replaceAll(' ', '')
          if (removedNewLines === '') {
            tab.remove()
          }
        })
      initiateCustomAccordions()

      if (document.querySelector('.sf-prod__block .customReview')) {
        
        if (document.querySelector('.sf-prod__block .customReview #reviewContent')) {
          let reviewData = document.querySelector(
            '.sf-prod__block .customReview #reviewContent'
          ).innerText
          reviewData = reviewData.replaceAll('=>', ':')
          reviewData = JSON.parse(reviewData)
          document.querySelector(
            '.sf-prod__block .customReview h3.collapsible__button span'
          ).innerText += ` (${reviewData.reviewCount})`
          if (+reviewData.reviewAverageValue > 0) {
            const reviewBadgeClone = document
              .querySelector(
                '.customReview .okeReviews-reviewsAggregate-summary-rating'
              )
              .cloneNode(true)
            document
              .querySelector(
                '.sf-prod__block .customReview h3.collapsible__button'
              )
              .appendChild(reviewBadgeClone)
            document
              .querySelector(
                '.sf-prod__block .customReview h3.collapsible__button'
              )
              .classList.add('okeReviews')
          }
        } else {
          document.querySelector(
            '.sf-prod__block .customReview h3.collapsible__button span'
          ).innerText += ` (0)`
        }
        
      }

      if (document.querySelector('.sf-prod__block .questionAndAnswers')) {
        const awaitOkendoQAInit = setInterval(() => {
          if (document.querySelector('.questionAndAnswers .okeReviews-qandaWidget')) {
            clearInterval(awaitOkendoQAInit)
            const questionsLength = document.querySelectorAll('.questionAndAnswers .okeReviews-qandaWidget .okeReviews-question')
            document.querySelector('.sf-prod__block .questionAndAnswers h3.collapsible__button span').innerText += ` (${questionsLength.length})`
          }
        }, 500)
      }
      if (
        document.querySelectorAll(
          '.sf-prod__container .collapsible__content .table'
        ).length > 1
      ) {
        document
          .querySelectorAll(
            '.sf-prod__container .collapsible__content .table th'
          )
          .forEach((header) => {
            let headerText = header.innerText.toLowerCase()
            let headerValue = header.parentElement.querySelector('td').innerText
            headerValue = headerValue.replace('<', '')
            headerValue = headerValue.replace('>', '')
            let iconPercentage;
            if (headerText.includes('calories')) {
                let iconPercentage = ((+headerValue)/100) * 100
                if(iconPercentage > 75){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0324/9681/2167/files/fullIcon.png?v=1678640123' class='cupIconImg' alt='100% full cup icon'>"
                }else if (iconPercentage > 50){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0324/9681/2167/files/75_fullIcon.png?v=1678640880' class='cupIconImg' alt='75% full cup icon'>"
                }else if(iconPercentage> 25){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.43_1.png?v=1674213565' class='cupIconImg' alt='50% full cup icon'>"
                }else if(iconPercentage >= 5){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.42_1.png?v=1674213565' alt='25% full cup icon' class='cupIconImg'>"
                }else{
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.43_2.png?v=1674213565' class='cupIconImg'>"
                }
            } else if (headerText.includes('sugar')) {
              let iconPercentage = ((+headerValue)/100) * 100
              if(iconPercentage > 75){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0324/9681/2167/files/fullIcon.png?v=1678640123' class='cupIconImg' alt='100% full cup icon'>"
                }else if (iconPercentage > 50){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0324/9681/2167/files/75_fullIcon.png?v=1678640880' class='cupIconImg' alt='75% full cup icon'>"
                }else if(iconPercentage> 25){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.43_1.png?v=1674213565' class='cupIconImg' alt='50% full cup icon'>"
                }else if(iconPercentage >= 5){
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.42_1.png?v=1674213565' alt='25% full cup icon' class='cupIconImg'>"
                }else{
                  header.parentElement.querySelector('td').innerHTML +=
                    "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.43_2.png?v=1674213565' class='cupIconImg'>"
                }
            } else if (headerText.includes('abv')) {
              let abvContent = headerValue;
              abvContent = abvContent.indexOf('%') ? abvContent.split('%')[0] : abvContent;
              if(abvContent >= (+1/100)){
                header.parentElement.querySelector('td').innerHTML +=
                  "<img src='https://cdn.shopify.com/s/files/1/0712/5850/5529/files/Screenshot_2022-12-19_at_10.43_2.png?v=1674213565' class='cupIconImg'>"
              }else{
                header.parentElement.querySelector('td').innerHTML +=
                  "<img src='https://cdn.shopify.com/s/files/1/0324/9681/2167/files/Screenshot_2022-12-19_at_10.43_2_5f03c671-cd27-45c0-84f2-bd0857ad75a0.png?v=1678936132' class='cupIconImg'>"
                
              }
            }
          })
      }
      
    // Moving Bundle & Save:
    if(document.querySelector('#fox-product-bundle-outside') && document.querySelector('.sf-prod-template .sf-product__section-tabs')){
      document.querySelector('.sf-prod-template .sf-product__section-tabs').appendChild(document.querySelector('#fox-product-bundle-outside'))
    }
      
    } */
  })()

  ;(function () {
    faqQuestions = document.querySelectorAll('.custom-questions__accordion h2')
    if (faqQuestions.length) {
      let newQuestionsContainer = document.createElement('div')
      newQuestionsContainer.className = 'customFAQAccordions'
      newQuestionsContainer.innerHTML = `<div class='container'>
            <div class="section__header text- ">
                <h2 class="section__heading">Popular questions</h2>
            </div>
            <div class="prod__accordion">
            </div>
            </div>`
      faqQuestions.forEach((q) => {
        let collapsibleItem = `<collapsible-tab class="collapsible__item no-js-hidden"> 
                    <h3 class="collapsible__button lg:text-[18px] py-4 pr-4 border-b border-color-border" data-trigger=""><span>`
        collapsibleItem += q.innerText + '</span></h3>'
        collapsibleItem +=
          `<div class="collapsible__content" data-content="" hidden="">
                    <div class="collapsible__content-inner pt-5 pb-10 prose"><p>` +
          q.nextElementSibling.innerHTML +
          `</p>  </div>
                </div>
                </collapsible-tab>`
        newQuestionsContainer.querySelector('.prod__accordion').innerHTML +=
          collapsibleItem
      })
      document
        .querySelector('.custom-questions__accordion')
        .parentElement.classList.add('sf-collapsible')
      document
        .querySelector('.custom-questions__accordion')
        .parentElement.classList.add('collectionFAQ')
      document
        .querySelector('.custom-questions__accordion')
        .parentElement.appendChild(newQuestionsContainer)
      document.querySelector('.custom-questions__accordion').remove()
    }else if(document.querySelectorAll('.custom-questions__accordion h3').length){
      //In case optizen makes the headers h3s instead of h2s
      faqQuestions = document.querySelectorAll('.custom-questions__accordion h3')
      let newQuestionsContainer = document.createElement('div')
      newQuestionsContainer.className = 'customFAQAccordions'
      newQuestionsContainer.innerHTML = `<div class='container'>
            <div class="section__header text- ">
                <h2 class="section__heading">Popular questions</h2>
            </div>
            <div class="prod__accordion">
            </div>
            </div>`
      faqQuestions.forEach((q) => {
        let collapsibleItem = `<collapsible-tab class="collapsible__item no-js-hidden"> 
                    <h3 class="collapsible__button lg:text-[18px] py-4 pr-4 border-b border-color-border" data-trigger=""><span>`
        collapsibleItem += q.innerText + '</span></h3>'
        collapsibleItem +=
          `<div class="collapsible__content" data-content="" hidden="">
                    <div class="collapsible__content-inner pt-5 pb-10 prose"><p>` +
          q.nextElementSibling.innerHTML +
          `</p>  </div>
                </div>
                </collapsible-tab>`
        newQuestionsContainer.querySelector('.prod__accordion').innerHTML +=
          collapsibleItem
      })
      document
        .querySelector('.custom-questions__accordion')
        .parentElement.classList.add('sf-collapsible')
      document
        .querySelector('.custom-questions__accordion')
        .parentElement.classList.add('collectionFAQ')
      document
        .querySelector('.custom-questions__accordion')
        .parentElement.appendChild(newQuestionsContainer)
      document.querySelector('.custom-questions__accordion').remove()
    }
  })()

  ;(function () {
    if (document.querySelector('#CollectionProductGrid')) {
      const waitForSortText = setInterval(() => {
        if (
          document.querySelector(
            '#CollectionProductGrid .select-selected > span'
          )
        ) {
          clearInterval(waitForSortText)
          document.querySelector(
            '#CollectionProductGrid .select-selected > span'
          ).innerText = 'Sort'
        }
      }, 1000)
    }
  })()

  ;(function () {
    if (document.querySelector('.viewMoreCategories')) {
      const viewMoreBtn = document.querySelector('.viewMoreCategories')
      if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', (e) => {
          e.preventDefault()
          viewMoreBtn.parentElement
            .querySelectorAll('.extraCategory')
            .forEach((category) => category.classList.remove('extraCategory'))
          viewMoreBtn.remove()
        })
      }
    }
  })()

  ;(function () {
    if (
      document.querySelector(
        '[data-section-type="article-template"] .articleProse'
      )
    ) {
      const recipe = document.querySelector('.mb-10.prose.max-w-none')
      let recipeHTML = recipe.innerHTML

      let recipesIndex, methodsIndex, notesIndex
      recipe.querySelectorAll('h5').forEach((h) => {
        const downcasedInner = h.innerText.toLowerCase()
        if (downcasedInner.indexOf('ingredients') != -1) {
          recipesIndex = recipeHTML.indexOf(h.outerHTML)
        } else if (h.innerText.indexOf('METHOD') != -1) {
          if (!h.parentElement.classList.contains('articleContent')) {
            methodsIndex = recipeHTML.indexOf(h.parentElement.outerHTML)
          } else methodsIndex = recipeHTML.indexOf(h.outerHTML)
        } else if (h.innerText.indexOf('NOTES') != -1) {
          if (!h.parentElement.classList.contains('articleContent')) {
            notesIndex = recipeHTML.indexOf(h.parentElement.outerHTML)
          } else notesIndex = recipeHTML.indexOf(h.outerHTML)
        }
      })

      if (!recipesIndex) recipesIndex = recipeHTML.indexOf('INGREDIENTS')
      if (!methodsIndex) methodsIndex = recipeHTML.indexOf('METHOD')
      if (!notesIndex) notesIndex = recipeHTML.indexOf('NOTES')

      let ingredientsHTML, methodsHTML
      if (recipesIndex) {
        if (methodsIndex) {
          if (methodsIndex > recipesIndex) {
            ingredientsHTML = recipeHTML.slice(recipesIndex, methodsIndex)
          } else {
            if (notesIndex && notesIndex > recipesIndex) {
              ingredientsHTML = recipeHTML.slice(recipesIndex, notesIndex)
            } else {
              ingredientsHTML = recipeHTML.slice(recipesIndex)
            }
          }
        } else if (notesIndex) {
          ingredientsHTML = recipeHTML.slice(recipesIndex, notesIndex)
        } else {
          ingredientsHTML = recipeHTML.slice(recipesIndex)
        }
      }
      /*
        if(methodsIndex){
        if(notesIndex){
                 methodsHTML = recipeHTML.slice(methodsIndex, notesIndex)
            }else{
                methodsHTML = recipeHTML.slice(methodsIndex)
            }
        }*/

      if (recipesIndex) {
        let startHTML, endHTML
        startHTML = recipeHTML.slice(0, recipesIndex)
        if (methodsIndex && methodsIndex > recipesIndex) {
          endHTML = recipeHTML.slice(methodsIndex)
          recipeHTML = startHTML + endHTML
        } else if (notesIndex && notesIndex > recipesIndex) {
          endHTML = recipeHTML.slice(notesIndex)
          recipeHTML = startHTML + endHTML
        }
      } /*else if(methodsIndex){
            recipeHTML = recipeHTML.slice(0, methodsIndex)
        }*/

      document.querySelector('.mb-10.prose.max-w-none').innerHTML = recipeHTML
      document.querySelector(
        '.mb-10.prose.max-w-none .ingredientsContainer'
      ).innerHTML = ingredientsHTML

      if (
        !document.querySelector(
          '.mb-10.prose.max-w-none .ingredientsContainer h5'
        )
      ) {
        const newIngredientsContainerTitleIndex = document
          .querySelector('.mb-10.prose.max-w-none .ingredientsContainer')
          .innerHTML.indexOf('INGREDIENTS')
        if (newIngredientsContainerTitleIndex != -1) {
          const newIngredientsContainerTitleHTML =
            ingredientsHTML.slice(0, newIngredientsContainerTitleIndex) +
            '<h5>Ingredients</h5><br>' +
            ingredientsHTML.slice(
              newIngredientsContainerTitleIndex + 'INGREDIENTS'.length
            )
          document.querySelector(
            '.mb-10.prose.max-w-none .ingredientsContainer'
          ).innerHTML = newIngredientsContainerTitleHTML
        }
      }

      if (
        !document.querySelector(
          '.mb-10.prose.max-w-none .ingredientsContainer p'
        ) 
      ) {
        const currentIngredientHTML = document.querySelector(
          '.mb-10.prose.max-w-none .ingredientsContainer'
        ).innerHTML
        document.querySelector(
          '.mb-10.prose.max-w-none .ingredientsContainer'
        ).innerHTML = currentIngredientHTML.slice(
          0,
          '<h5>INGREDIENTS</h5>'.length
        )
        document.querySelector(
          '.mb-10.prose.max-w-none .ingredientsContainer'
        ).innerHTML += '<p class= "wrapper-para"></p>'
        document.querySelector(
          '.mb-10.prose.max-w-none .ingredientsContainer p.wrapper-para'
        ).innerHTML = currentIngredientHTML.slice('<h5>INGREDIENTS</h5>'.length)
      }
      var list = '<ul>'
      var items = document
        .querySelector('.mb-10.prose.max-w-none .ingredientsContainer p')
        .innerHTML.split('<br>')
      for (var i = 0; i < items.length; i++) {
        if (items[i] != '' && items[i] != '\n' && items[i].length > 1)
          list +=
            "<li><input type='checkbox'><p class='ingredient'>" +
            items[i] +
            '</p></li>'
      }
      list += '</ul>'
      document.querySelector(
        '.mb-10.prose.max-w-none .ingredientsContainer p'
      ).innerHTML = list

      document
        .querySelectorAll('.mb-10.prose.max-w-none h5')
        .forEach((heading) => {
          heading.innerText =
            heading.innerText.slice(0, 1).toUpperCase() +
            heading.innerText.slice(1).toLowerCase()
        })
    }
  })()

  ;(function () {
    if (document.querySelector('.popular-blogs')) {
      document.querySelectorAll('.popular-blogs').forEach((blog) => {
        const checkSwiperInit = setInterval(() => {
          if (blog.querySelector('.sf-grid').swiper) {
            clearInterval(checkSwiperInit)
            blog.querySelector('.sf-grid').swiper.destroy()
            new Swiper(blog.querySelector('.sf-grid'), {
              slidesPerView: 5,
              loop: true,
              allowSlideNext: true,
              allowSlidePrev: true,
              allowTouchMove: true,
            })
          }
        }, 1000)
      })
    }
  })()

  ;(function () {
  if (document.querySelector('.featuredRecipes')) {
    document.querySelectorAll('.featuredRecipes .featuredRecipesContainer').forEach((featuredRecipes) => {
      var init = false
      function featuredRecipesSwiper() {
        if (window.innerWidth <= 1024) {
          if (!init) {
            init = true
            swiper = new Swiper(
              featuredRecipes,
              {
                slidesPerView: 1.395833333333333,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                spaceBetween: 20,
              })
          }
        } else if (init) {
          swiper.destroy()
          init = false
        }
      }
      featuredRecipesSwiper()
      window.addEventListener('resize', featuredRecipesSwiper)
    })
  }
  })()
    
  ;(function () {
    if (
      document.querySelector('.reviews-custom-slider') ||
      document.querySelector('.article-specific-products-slider')
    ) {
      document
        .querySelectorAll('.reviews-custom-slider')
        .forEach((reviewSlider) => {
          const checkSwiperInit = setInterval(() => {
            if (reviewSlider.querySelector('.sf-grid').swiper) {
              clearInterval(checkSwiperInit)
              reviewSlider.querySelector('.sf-grid').swiper.destroy()
              new Swiper(reviewSlider.querySelector('.sf-grid'), {
                slidesPerView: 3.515,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                breakpoints: {
                  300: {
                    slidesPerView: 1.395833333333333,
                    loop: false,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    allowTouchMove: true,
                  },
                  768: {
                    slidesPerView: 3.515,
                    loop: false,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    allowTouchMove: true,
                  },
                },
              })
            }
          }, 1000)
        })
      document
        .querySelectorAll('.article-specific-products-slider')
        .forEach((articleSpecificProductsSlider) => {
          const checkArticleSwiperInit = setInterval(() => {
            if (
              articleSpecificProductsSlider.querySelector('.sf-grid').swiper
            ) {
              clearInterval(checkArticleSwiperInit)
              articleSpecificProductsSlider
                .querySelector('.sf-grid')
                .swiper.destroy()
              if (
                articleSpecificProductsSlider.querySelectorAll('.swiper-slide').length > 1
              ) {
                if (
                  articleSpecificProductsSlider.querySelectorAll('.swiper-slide').length <= 4
                ) {
                  var init = false
                  function swiperCard() {
                    if (window.innerWidth <= 768) {
                      if (!init) {
                        init = true
                        swiper = new Swiper(
                          articleSpecificProductsSlider.querySelector(
                            '.sf-grid'
                          ),
                          {
                            slidesPerView: 1.395833333333333,
                            loop: false,
                            allowSlideNext: true,
                            allowSlidePrev: true,
                            allowTouchMove: true,
                          }
                        )
                      }
                    } else if (init) {
                      swiper.destroy()
                      init = false
                    }
                  }
                  swiperCard()
                  window.addEventListener('resize', swiperCard)
                } else {
                  new Swiper(
                    articleSpecificProductsSlider.querySelector('.sf-grid'),
                    {
                      slidesPerView: 3.515,
                      loop: false,
                      allowSlideNext: true,
                      allowSlidePrev: true,
                      allowTouchMove: true,
                      breakpoints: {
                        300: {
                          slidesPerView: 1.395833333333333,
                          loop: false,
                          allowSlideNext: true,
                          allowSlidePrev: true,
                          allowTouchMove: true,
                        },
                        768: {
                          slidesPerView: 3.515,
                          loop: false,
                          allowSlideNext: true,
                          allowSlidePrev: true,
                          allowTouchMove: true,
                        },
                      },
                    }
                  )
                }
              }
            }
          }, 1000)
        })
    }
  })()

  ;(function () {
    if (document.querySelector('.blogTab')) {
      document.querySelectorAll('.blogTab').forEach((blogTab, index) => {
        const checkSwiperInit = setInterval(() => {
          if (blogTab.querySelector('.sf-grid').swiper || index > 0) {
            clearInterval(checkSwiperInit)
            blogTab.querySelector('.sf-grid').swiper?.destroy()
            new Swiper(blogTab.querySelector('.sf-grid'), {
              slidesPerView: 3.515,
              loop: false,
              allowSlideNext: true,
              allowSlidePrev: true,
              allowTouchMove: true,
              pagination: {
                el: blogTab.querySelector('.swiper-pagination'),
                bulletElement: 'span',
                clickable: false,
                hideOnClick: false,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: false,
                type: 'bullets',
                // 'bullets' or 'progressbar' or 'fraction' or 'custom'
                dynamicBullets: false,
                dynamicMainBullets: 1,
                formatFractionCurrent: function formatFractionCurrent(number) {
                  return number
                },
                formatFractionTotal: function formatFractionTotal(number) {
                  return number
                },
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                modifierClass: 'swiper-pagination-',
                // NEW
                currentClass: 'swiper-pagination-current',
                totalClass: 'swiper-pagination-total',
                hiddenClass: 'swiper-pagination-hidden',
                progressbarFillClass: 'swiper-pagination-progressbar-fill',
                progressbarOppositeClass:
                  'swiper-pagination-progressbar-opposite',
                clickableClass: 'swiper-pagination-clickable',
                // NEW
                lockClass: 'swiper-pagination-lock',
              },
              breakpoints: {
                300: {
                  slidesPerView: 1.395833333333333,
                  loop: false,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
                768: {
                  slidesPerView: 3.515,
                  loop: false,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
              },
            })
          }
        }, 1000)
      })
    }
  })()
  ;(function () {
    if (document.querySelector('.relatedArticles ')) {
      swiper = new Swiper('.relatedArticles .sf__ms', {
              slidesPerView: 2.5,
              spaceBetween: 20,
              breakpoints: {
                300: {
                  slidesPerView: 1.395833333333333,
                  loop: false,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
                768: {
                  slidesPerView: 5,
                  loop: false,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
              },
            })
      /*
      var init = false

      function relatedPostsSwiper() {
        if (window.innerWidth <= 1024) {
          if (!init) {
            init = true
            swiper = new Swiper('.relatedArticles .sf__ms', {
              slidesPerView: 2.5,
              spaceBetween: 20,
              breakpoints: {
                300: {
                  slidesPerView: 1.395833333333333,
                  loop: false,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
                768: {
                  slidesPerView: 3.515,
                  loop: false,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
              },
            })
          }
        } else if (init) {
          swiper.destroy()
          init = false
        }
      }
      relatedPostsSwiper()
      window.addEventListener('resize', relatedPostsSwiper)*/
    }
  })()
  ;(function () {
    if (
      document.querySelector('.sf-product__section.product-recommendations')
    ) {
      document
        .querySelectorAll('.sf-product__section.product-recommendations')
        .forEach((reccomendationSlider) => {
          let time = 0
          const checkSwiperInit = setInterval(() => {
            if (
              reccomendationSlider.querySelector('.sf-grid') &&
              reccomendationSlider.querySelector('.sf-grid').swiper
            ) {
              clearInterval(checkSwiperInit)
              reccomendationSlider.querySelector('.sf-grid').swiper.destroy()
              new Swiper(reccomendationSlider.querySelector('.sf-grid'), {
                slidesPerView: 4,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                breakpoints: {
                  300: {
                    slidesPerView: 1.395833333333333,
                    loop: false,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    allowTouchMove: true,
                  },
                  768: {
                    slidesPerView: 4,
                    loop: true,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    allowTouchMove: true,
                  },
                },
              })
            } else if (time === 15000) {
              clearInterval(checkSwiperInit)
            }
            time += 1500
          }, 1000)
        })
    }
  })()

  ;(function () {
if (document.querySelector('.blog_products_section')) {
  document.querySelectorAll('.blog_products_section .sf-grid').forEach((customCollectionSlider) => {
    new Swiper(customCollectionSlider, {
            slidesPerView: 4,
            loop: false,
            allowSlideNext: true,
            allowSlidePrev: true,
            allowTouchMove: true,
            spaceBetween: 20,
            breakpoints: {
              300: {
                slidesPerView: 1.375,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                spaceBetween: 15,
              },
              400: {
                slidesPerView: 2,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                spaceBetween: 15,
              },
              600: {
                slidesPerView: 3,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                spaceBetween: 15,
              },
              900: {
                slidesPerView: 4,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                spaceBetween: 15,
              },
              1200: {
                slidesPerView: 5,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                spaceBetween: 25,
              }
            },
          })
  })
}
})()
  ;(function () {
    if (document.querySelector('.sf-tab-content .sf__ms--slider ')) {
      document
        .querySelectorAll('.sf-tab-content .sf__ms--slider')
        .forEach((productTab) => {
          const checkSwiperInit = setInterval(() => {
            if (productTab.querySelector('.sf-grid').swiper) {
              clearInterval(checkSwiperInit)
              productTab.querySelector('.sf-grid').swiper.destroy()
              new Swiper(productTab.querySelector('.sf-grid'), {
                slidesPerView: 5,
                loop: false,
                allowSlideNext: true,
                allowSlidePrev: true,
                allowTouchMove: true,
                breakpoints: {
                  300: {
                    slidesPerView: 1.395833333333333,
                    loop: false,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    allowTouchMove: true,
                  },
                  768: {
                    slidesPerView: 5,
                    loop: false,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    allowTouchMove: true,
                  },
                },
                pagination: {
                  el: productTab
                    .querySelector('.sf-grid')
                    .parentElement.querySelector('.swiper-pagination'),
                  bulletElement: 'span',
                  clickable: false,
                  hideOnClick: false,
                  renderBullet: null,
                  renderProgressbar: null,
                  renderFraction: null,
                  renderCustom: null,
                  progressbarOpposite: false,
                  type: 'bullets',
                  // 'bullets' or 'progressbar' or 'fraction' or 'custom'
                  dynamicBullets: false,
                  dynamicMainBullets: 1,
                  formatFractionCurrent: function formatFractionCurrent(
                    number
                  ) {
                    return number
                  },
                  formatFractionTotal: function formatFractionTotal(number) {
                    return number
                  },
                  bulletClass: 'swiper-pagination-bullet',
                  bulletActiveClass: 'swiper-pagination-bullet-active',
                  modifierClass: 'swiper-pagination-',
                  // NEW
                  currentClass: 'swiper-pagination-current',
                  totalClass: 'swiper-pagination-total',
                  hiddenClass: 'swiper-pagination-hidden',
                  progressbarFillClass: 'swiper-pagination-progressbar-fill',
                  progressbarOppositeClass:
                    'swiper-pagination-progressbar-opposite',
                  clickableClass: 'swiper-pagination-clickable',
                  // NEW
                  lockClass: 'swiper-pagination-lock',
                },
              })
            }
          }, 1000)
        })
    }
  })()
  ;(function () {
    if (document.querySelector('.viewMoreBlogsBtn')) {
      document
        .querySelector('.viewMoreBlogsBtn')
        .addEventListener('click', (e) => {
          e.preventDefault()
          const blogTemplateParent = e.target.closest(
            '[data-section-type="blog-template"]'
          )
          if (blogTemplateParent) {
            const loadedBlogPosts =
              blogTemplateParent.querySelectorAll('.sf__blog-card')
            for (
              var i = loadedBlogPosts.length;
              i < loadedBlogPosts.length + 20;
              i++
            ) {
              if(window.blogPosts[i]){
                const temp = document.createElement('div')
                temp.innerHTML += window.blogPosts[i]
                blogTemplateParent.querySelector('.grid').appendChild(temp.querySelector('.sf__blog-card'))
              }
            }
            if(loadedBlogPosts.length + 20 >= window.blogPosts.length){
               document.querySelector('.viewMoreBlogsBtn').remove()
            }
          }
        })
    }
  })()

  ;(function () {
    /**Account Drawer**/
    const accountDrawer = document.querySelector('.sf-customer-section')
    const accountDrawerWrapper = document.createElement('div')
    accountDrawerWrapper.classList.add('accountDrawerWrapper')
    accountDrawerWrapper.classList.add('bg-black')
    accountDrawerWrapper.classList.add('hidden')
    accountDrawer.parentElement.insertBefore(
      accountDrawerWrapper,
      accountDrawer
    )
    accountDrawerWrapper.appendChild(accountDrawer)
    accountDrawer.parentElement.style.setProperty('--tw-bg-opacity', '0')

    accountDrawer.querySelector('.register.sf-user-tab-label span').innerText =
      'Sign up'
    let accountDrawerOpening = false
    accountDrawer.querySelector('.close-btn').addEventListener('click', (e) => {
      accountDrawerOpening = true
      accountDrawer.parentElement.style.setProperty('--tw-bg-opacity', '0')
      setTimeout(() => {
        accountDrawer.parentElement.classList.add('hidden')
        accountDrawerOpening = false
      }, 500)
    })

    document.querySelectorAll('.accountLink').forEach((ele) =>
      ele.addEventListener('click', (e) => {
        e.preventDefault()
        accountDrawerOpening = true
        accountDrawer.parentElement.classList.remove('hidden')
        setTimeout(() => {
          accountDrawer.classList.add('-translate-x-full')
          accountDrawer.parentElement.style.setProperty(
            '--tw-bg-opacity',
            '0.5'
          )
          accountDrawerOpening = false
        }, 100)
      })
    )

    let runningAccountTabChange = false
    accountDrawer
      .querySelectorAll('.accountDrawerHeader .accountDrawerLink')
      .forEach((accLink) => {
        accLink.addEventListener('click', (e) => {
          e.preventDefault()
          if (
            accLink.classList.contains('activeFormLink') ||
            runningAccountTabChange
          )
            return true
          runningAccountTabChange = true
          accLink.parentElement
            .querySelector('.activeFormLink')
            .classList.remove('activeFormLink')
          accLink.classList.add('activeFormLink')
          const currentActive =
            accLink.parentElement.parentElement.querySelector('.activeForm')
          const newActive = accLink.parentElement.parentElement.querySelector(
            `.formContainer[data-tab-index="${accLink.getAttribute(
              'data-tab-index'
            )}"]`
          )
          currentActive.classList.remove('activeForm')
          setTimeout(() => {
            currentActive.classList.add('hidden')
            newActive.classList.remove('hidden')
            setTimeout(() => {
              newActive.classList.add('activeForm')
              runningAccountTabChange = false
            }, 100)
          }, 500)
        })
      })

    accountDrawer.querySelectorAll('form', (form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const response = await fetch('/account/login', {
          method: 'POST',
          data: {
            email: 'sda',
            password: 'asd',
          },
        })
        console.log(response)
      })
    })
    /**Account Drawer End**/
  })()

  ;(function () {
    if (window._themeProducts) {
      console.log("dcdd");
        
      let currentProductPrice =
        window._themeProducts[Object.keys(window._themeProducts)].selected_or_first_available_variant.price / 100
      document.querySelector('.product-form__actions .form__input-wrapper quantity-input input').addEventListener('change', (e) => {
          document.querySelector('.product-form__actions .add-to-cart.sf__btn .f-price-item').innerText = '$' + (currentProductPrice * +e.target.value).toFixed(2)
        })
      const selectedVariantInput = document.querySelector('.product-options input[type=radio]')
      if( selectedVariantInput ){
        selectedVariantInput.addEventListener('change', (e) => {
          
          
          const checkedVariant = window._themeProducts[
            Object.keys(window._themeProducts)
          ].variants.find((item) => item.id === +selectedVariantInput.value)
  
          if (checkedVariant) {
  
             console.log("222dcdd");
            currentProductPrice = checkedVariant.price / 100
            
            document.querySelector(
              '.product-form__actions .add-to-cart.sf__btn .f-price-item'
            ).innerText =
              '$' +
              (
                currentProductPrice *
                +document.querySelector(
                  '.product-form__actions .form__input-wrapper quantity-input input'
                ).value
              ).toFixed(2)
            //Reward Points
            document.querySelector(
              '.main-product__blocks .rewards-points .point'
            ).innerText = Math.ceil(currentProductPrice * 3)
            //Change Sale Tag
            /*if(checkedVariant.compare_at_price || document.querySelector('.prod__option--button .variant-picker__option input:checked').parentElement.querySelector('.showPriceAsCompare')){
                        let compareAtPrice;
                        if(checkedVariant.compare_at_price){
                          compareAtPrice = checkedVariant.compare_at_price;
                        }else{
                          compareAtPrice = (+document.querySelector('.prod__option--button .variant-picker__option input:checked').parentElement.querySelector('.showPriceAsCompare').innerText.split('$')[1] * 100).toFixed(2)
                        }
                          const percentOff = Math.ceil(((compareAtPrice - checkedVariant.price).toFixed(2) / compareAtPrice).toFixed(2) * 100);
                        if(document.querySelectorAll(`.sf-product-media__desktop .saleTagCustom, .product-mb__media .saleTagCustom`).length){
                          document.querySelectorAll(`.sf-product-media__desktop .saleTagCustom, .product-mb__media .saleTagCustom`).forEach(saleTag=>{
                            saleTag.querySelector('.actualPercentageOff').innerText = percentOff + '%'
                          })
                        }else{
                          const saleTag = document.createElement('div')
                          saleTag.classList.add('saleTagCustom')
                          saleTag.innerHTML += `<span class="actualPercentageOff">${percentOff}%</span> OFF`
                          document.querySelectorAll(`.sf-product-media__desktop, .product-mb__media`).forEach(mediaContainer=>
                            {
                              mediaContainer.appendChild(saleTag)
                            })
                        }  
                      }else{
                        if(document.querySelectorAll(`.sf-product-media__desktop .saleTagCustom, .product-mb__media .saleTagCustom`).length){
                          document.querySelectorAll(`.sf-product-media__desktop .saleTagCustom, .product-mb__media .saleTagCustom`).forEach(saleTag=>saleTag.remove())
                        }
                      }*/
          }
        })
      }

      // Clicking On review stars opens review section:
      document
        .querySelector('.main-product__blocks [data-oke-star-rating]')
        .addEventListener('click', (e) => {
          document
            .querySelector('collapsible-tab-custom.customReview')
            .scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            })
          setTimeout(() => {
            document
              .querySelector(
                'collapsible-tab-custom.customReview .collapsible__button '
              )
              .click()
          }, 1000)
        })
    }
  })()

  ;(function () {
    if (document.querySelector('.main-product__block-buyNowPayLater')) {
      document
        .querySelectorAll(
          '.main-product__block-buyNowPayLater .buyNowPayLaterSelector'
        )
        .forEach((selector) => {
          selector.addEventListener('click', (e) => {
            if (selector.classList.contains('active')) return
            selector.parentElement
              .querySelector('.active')
              .classList.remove('active')
            selector.classList.add('active')

            const selectorContainer = selector.closest(
              '.buyNowPayLaterSelectorContainer'
            )
            const currentActive = selectorContainer.querySelector(
              '.selectorContentContainer .active'
            )
            const newActive = selectorContainer.querySelector(
              '.selectorContentContainer > div:not(.active)'
            )

            currentActive.classList.remove('active')
            setTimeout(() => {
              currentActive.style.display = 'none'
              newActive.style.display = 'block'

              setTimeout(() => {
                newActive.classList.add('active')
              }, 100)
            }, 500)
          })
        })
    }
  })()

  ;(function () {
    
  })()

  ;(function () {
    document.querySelectorAll('[data-popular-searches] a[data-ps-query]').forEach((popularSearch) => {
        popularSearch.addEventListener('click', (e) => {
          e.preventDefault()
          document.querySelector('[data-search-popup] form input[data-search-input]').value = popularSearch.innerText
          document.querySelector('[data-search-popup] form input[data-search-input]').focus()
        })
      })

    document.querySelector('[data-open-search-popup]').addEventListener('click', (e) => {
        const isMobile = window.matchMedia('(max-width: 768px)')
        if (isMobile.matches) {
          // document.querySelector('.search-close-header button[data-close-search]').click()
          if (
            document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').style.display == 'none' ||
            document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').style.display == ''
          ) {
            document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').classList.remove('customTransition-hidden')
            document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').classList.remove('customTransition-visible')
            document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').classList.add('customTransition-hidden')
            document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').style.display = 'block'
            setTimeout(() => {
              document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').classList.add('customTransition-visible')
            }, 100)
          }
        }
      })
  })()

  ;(function () {
    /** Collection Description Truncation **/
    const descriptionContainer = document.querySelector(
      '.boost-pfs-filter-collection-description'
    )
    if (descriptionContainer) {
      const descriptionLineHeight = window
        .getComputedStyle(descriptionContainer, null)
        .getPropertyValue('line-height')
        .split('px')[0]
      if (descriptionContainer.offsetHeight > descriptionLineHeight * 3) {
        descriptionContainer.style.maxHeight = descriptionLineHeight * 3 + 'px'
        const readMoreLink = document.createElement('div')
        readMoreLink.innerHTML = `<div class="readMoreLink"><a href="#">Read More</a></div>`
        readMoreLink.querySelector('a').addEventListener('click', (e) => {
          e.preventDefault()
          const increaseBy =
            descriptionContainer.scrollHeight > 500
              ? descriptionContainer.scrollHeight
              : 500
          descriptionContainer.style.maxHeight = increaseBy + 'px'
          readMoreLink.remove()
          descriptionContainer.classList.remove('truncated')
          if (window.pinFilterBtnOnMobile && window.pinFilterBtnOnMobile.kill) {
            setTimeout(() => {
              window.pinFilterBtnOnMobile.kill()
              window.pinFilterBtnOnMobile = ScrollTrigger.create({
                trigger: '.boost-pfs-filter-tree-mobile-button',
                pin: '.boost-pfs-filter-tree-mobile-button ',
                start: 'top 50px',
                end:
                  document.querySelector('.boost-pfs-filter-right-col')
                    .offsetHeight -
                  innerHeight +
                  'px end',
              })
            }, 600)
          }
        })
        descriptionContainer.parentElement.insertBefore(
          readMoreLink,
          descriptionContainer
        )
        descriptionContainer.classList.add('truncated')
      }
    }
    /** Collection Description Truncation End **/
  })()

  /*
    if(document.querySelector('.installment-shoppay')){
    //Check if recharge widget will be initialized within 20 seconds. Else timeout
    let checkRechargeTime = 0;
    const checkRecharge = setInterval(()=>{
      if(document.querySelector('.rc-container')){
        clearInterval(checkRecharge)
        document.querySelector('.rc-container .rc-template__button-group').appendChild(document.querySelector('.rc-container .rc_popup'))
        const svgContainer = document.createElement("div");
        svgContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path d="M8.50008 11.3333V8.49996M8.50008 5.66663H8.50716M15.5834 8.49996C15.5834 12.412 12.4121 15.5833 8.50008 15.5833C4.58806 15.5833 1.41675 12.412 1.41675 8.49996C1.41675 4.58794 4.58806 1.41663 8.50008 1.41663C12.4121 1.41663 15.5834 4.58794 15.5834 8.49996Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`
        document.querySelector('.rc-container .rc_popup .rc_popup__hover button.rc_popup_label_wrapper').insertBefore(svgContainer.querySelector('svg'), document.querySelector('.rc-container .rc_popup .rc_popup__hover button.rc_popup_label_wrapper .rc_popup__label'))
         document.querySelectorAll('.rc-container .rc_popup__learn_more').forEach(learnMore=>{
           learnMore.innerText = 'Find out more'
           learnMore.href = '/pages/subscription-details';
         })
      }else{
        checkRechargeTime += 1000;
        if(checkRechargeTime === 20000){
          clearInterval(checkRecharge)
        }
      }
    },1000)
  }*/


  
})

     document.addEventListener('variant:change', function(evt) {
  console.log("thismnmnm"+evt.detail.variant);
});

  console.log("texttttt");
            /* new Swiper('.announcement-bar__content',
              {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                 speed:3000,
                autoplay: {
                  delay:2000,
                  disableOnInteraction: false,
                },
              }
            ) */

            new Swiper('.blogTab-2 .sf-grid',
               {
              slidesPerView: 3.515,
              allowSlideNext: true,
              allowSlidePrev: true,
              allowTouchMove: true,
              loop: true,
                 initialSlide: 2,
      pagination: {
                el:'.swiper-pagination',
                bulletElement: 'span',
                clickable: true,
                hideOnClick: false,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: false,
                type: 'bullets',
                // 'bullets' or 'progressbar' or 'fraction' or 'custom'
                dynamicBullets: false,
                dynamicMainBullets: 1,
                formatFractionCurrent: function formatFractionCurrent(number) {
                  return number
                },
                formatFractionTotal: function formatFractionTotal(number) {
                  return number
                },
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                modifierClass: 'swiper-pagination-',
                // NEW
                currentClass: 'swiper-pagination-current',
                totalClass: 'swiper-pagination-total',
                hiddenClass: 'swiper-pagination-hidden',
                progressbarFillClass: 'swiper-pagination-progressbar-fill',
                progressbarOppositeClass:
                  'swiper-pagination-progressbar-opposite',
                clickableClass: 'swiper-pagination-clickable',
                // NEW
                lockClass: 'swiper-pagination-lock',
              },
              breakpoints: {
                300: {
                  slidesPerView: 2.395833333333333,
                  loop: true,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
                768: {
                  slidesPerView: 3.515,
                  loop: true,
                  allowSlideNext: true,
                  allowSlidePrev: true,
                  allowTouchMove: true,
                },
              },
              })

         document.addEventListener('variant:change', function(evt) {
});

$(document).ready(function(){
  $('m-featured-collection .blogTab.blogTab-2').on('click', '.sf-slider__controls button.swiper-button-prev', function(e){
    e.preventDefault();

    var activeBullet = $('m-featured-collection .blogTab.blogTab-2 .swiper-pagination-bullet.swiper-pagination-bullet-active');
    var prevBullet = activeBullet.prev('m-featured-collection .blogTab.blogTab-2 .swiper-pagination-bullet');
    prevBullet.trigger('click');
  })

  $('m-featured-collection .blogTab.blogTab-2').on('click', '.sf-slider__controls button.swiper-button-next', function(event){
    event.preventDefault();

    var activeBullet = $('m-featured-collection .blogTab.blogTab-2 .swiper-pagination-bullet.swiper-pagination-bullet-active');
    var nextBullet = activeBullet.next('m-featured-collection .blogTab.blogTab-2 .swiper-pagination-bullet');
    nextBullet.trigger('click');
  })
  
   $('.sf-menu-close').click(function() {
        $('.sf-menu-wrapper').addClass('hiddena').removeClass('displaymenu');
    });

    $('.sf-menu-button').click(function() {
        $('.sf-menu-wrapper').addClass('displaymenu').removeClass('hiddena');
    });
    
})